<template lang="pug">
  el-tabs(v-model="activeName" class="demo-tabs" @tab-click="handleClick")
    el-tab-pane(label="介绍" name="first")
      div(v-html="liveDetail")
    el-tab-pane(label="互动" name="second")
      ul.live-im-list
        li.live-im-item(v-for="item in imLists" :key="item.id")
          div.live-avatar
            img(:src="item.avatar || avatar")
          div.live-im-con
            p.live-im-name {{item.userName}}
            p.live-im-desc(v-if="item.id==='admin'" v-html="item.imContent")
            p.live-im-desc(v-else) {{item.imContent}}
</template>
<script>
import imlogo from '@/assets/img/imlogo.png';
import avatar from '@/assets/img/avatar.png';
export default {
  name: 'indexTabs',
  data() {
    return {
      avatar,
      activeName: 'first',
    };
  },
  props: {
    liveDetail: {},
    imList: [],
  },
  computed: {
    imLists() {
      const newData = this.imList.filter(item => item.imType === 'TIMTextElem');
      newData.unshift({
        createTime: 1663918432,
        id: 'admin',
        imContent: "欢迎进入直播间：<br> 1、请自行调整手机音量至合适状态。<br> 2、直播页面展示讲师发布内容，听众可在讨论区发言。",
        imType: "TIMTextElem",
        userName: "芳草教育直播助手",
        avatar: imlogo,
      });
      return newData;
    }
  },
  methods: {
    handleClick: (tab, event) => {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="stylus" scoped>
.demo-tabs
  padding-bottom 54px
.demo-tabs > .el-tabs__content
  padding 32px
  color #686868
  font-size 22px
  font-weight 600
::v-deep .el-tabs__item
  color #686868 !important
  font-size 16px
  font-family Microsoft YaHei
::v-deep .el-tabs__item:hover
  color #080808 !important
::v-deep .el-tabs__item.is-active
  color #080808 !important
  font-weight bold
::v-deep .el-tabs__active-bar
  background-color #58c3b1 !important
.live-im-list
  height: 50vh
  overflow-y auto
.live-im-item
  display flex
  .live-avatar
    flex: 0 0 30px
    img
      width 100%
      vertical-align middle
.live-im-con
  flex 1
  margin-left 10px
.live-im-name
  color #ADB5BF
  font-size 12px
.live-im-desc
  margin-top 10px
  border-radius 15px
  padding 15px
  background #F6F6F6
  color #000104
  box-sizing border-box
  display inline-block
  line-height 1.4
#pane-first
  width 100%
#pane-first img
  width 100%!important
</style>
